import { Button } from "@chakra-ui/react"
import { useState } from "react";
import { useBilling, useToastNotification } from "lib/hooks";
import { teamClient } from "lib/clients";
import { path } from "ramda";

const getStatus = path(['plan', 'status']);

export const ReSubscribe = () => {
  const { data, mutate } = useBilling();
  const [isPending, setIsPending] = useState<boolean>(false);
  const { errorToast } = useToastNotification();

  if (getStatus(data) !== 'canceled') {
    return null;
  }

  const resubSubscription = async () => {
    try {
      setIsPending(true)

      await teamClient.updateSubscription({
        cancel: false,
      });

      await mutate();
    } catch (err) {
      errorToast({ title: 'Error', description: 'Could not resubscribe, please try again' })
    } finally {
      setIsPending(false);
    }
  }

  return (
    <>
      <Button size="sm" variant="primary" onClick={resubSubscription} isLoading={isPending}>
        Reactivate Subscription
      </Button>
    </>
  )
}
